import { graphql, useStaticQuery } from "gatsby";

interface ISiteMetadata {
    title: string;
    description: string;
    siteUrl: string;
    keywords: string;
}

export const useSiteMetadata = () => {
    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    siteUrl
                    keywords
                }
            }
        }
    `);

    return site.siteMetadata as ISiteMetadata;
};
